import React from 'react'
import { StSep1 } from './style.css'
import Survey from '@/components/Survey'
import Countdown from '@/components/Countdown2'
import moment from 'moment'

const Questions = ({
  video,
  author,
  title,
  aside,
  webinarid,
  webinarmeta,
  banner,
  sponsors,
  survey,
  className,
  backgroundtype = 'clear',
}) => {
  const surveytime = moment(webinarmeta.start).add(15, 'minutes').toISOString()
  console.log(surveytime)
  return (
    <div className={className}>
      <StSep1>
        <h6 className="sm:px-8 px-4 py-2">
          <span className="font-bold block leading-tight">Feedback</span>{' '}
          <small className="block leading-none">Preguntas</small>
        </h6>
      </StSep1>
      <Countdown datetime={surveytime}>
        <Survey
          video={video}
          author={author}
          title={title}
          aside={aside}
          webinarid={webinarid}
          webinarmeta={webinarmeta}
          banner={banner}
          sponsors={sponsors}
          survey={survey}
          backgroundtype={backgroundtype}
        />
      </Countdown>
    </div>
  )
}

export default Questions
